import * as React from "react";
import { AlignmentButton, ButtonsContainer } from "./AlignmentButtons.styles";
import { IAlignmentButtonsProps } from "./types";

export const AlignmentButtons: React.FC<IAlignmentButtonsProps> = ({ showAlignmentButtons, alignImage }) => {
  if (!showAlignmentButtons) {
    return null;
  }
  return (
    <ButtonsContainer>
      <AlignmentButton onClick={alignImage("left")}>L</AlignmentButton>
      <AlignmentButton onClick={alignImage("none")}>C</AlignmentButton>
      <AlignmentButton onClick={alignImage("right")}>R</AlignmentButton>
    </ButtonsContainer>
  );
};
